export default import.meta.ROLLDOWN_FILE_URL_DueZVIzS4HsGzXaSiwy1Hg